import PrimaryNavigation from '../components/ui/primaryNavigation';

const PrivateLayout = ({ children, ...props }) => {
  return <PrimaryNavigation>{children}</PrimaryNavigation>;
};

export default PrivateLayout;
